import { connect } from 'react-redux';
import Recaptcha from './Recaptcha';

function mapStateToProps({ config }) {
  return {
    sitekey: config.recaptchaSiteKey,
  };
}

export default connect(mapStateToProps)(Recaptcha);
